import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
var paddingBottomPixels = 24;
var builtInButtonSize = 24;
export var useCarouselListBuiltInNavStyles = makeStyles({
    button: __assign(__assign({ backgroundColor: tokens.colorNeutralBackground1, color: tokens.colorNeutralForeground2, height: "".concat(builtInButtonSize, "px"), width: "".concat(builtInButtonSize, "px") }, shorthands.borderRadius("".concat(builtInButtonSize / 2, "px"))), { ':hover': {
            color: tokens.colorNeutralForeground2Hover,
            backgroundColor: tokens.colorNeutralBackground2Hover,
        }, ':focus': {
            outlineColor: tokens.colorStrokeFocus2,
            outlineStyle: 'auto',
            outlineWidth: '1px',
        } }),
    container: {
        marginTop: "-".concat((paddingBottomPixels + builtInButtonSize) / 2, "px"),
        position: 'absolute',
        top: '50%',
        zIndex: 100, // $TODO: $ms-zIndex-1 Does vNext have these?
    },
    containerNext: {
        right: 0,
    },
});
//# sourceMappingURL=CarouselListBuiltInNavControl.styles.js.map